import { z } from "zod";

const identificationDocumentDataSchema = z.object({
	identificationDocumentId: z
		.union([z.string().min(1), z.number()])
		.transform(String),
});

export type IdentificationDocumentData = z.infer<
	typeof identificationDocumentDataSchema
>;

export const parseIdentificationDocumentData = (
	data: unknown,
): IdentificationDocumentData | null => {
	const result = identificationDocumentDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
